import { render, staticRenderFns } from "./v-custom-data-table.vue?vue&type=template&id=66272984"
import script from "./v-custom-data-table.vue?vue&type=script&lang=ts"
export * from "./v-custom-data-table.vue?vue&type=script&lang=ts"
import style0 from "./v-custom-data-table.vue?vue&type=style&index=0&id=66272984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports